<!--
 * @Author: 317473294@qq.com
 * @Date: 2022-07-01 10:16:44
 * @LastEditTime: 2024-09-29 22:28:58
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /frontEnd/src/components/word/zdzy-dialog-hand-add.vue
-->

<template>
    <div class="el-dialog">
        <el-dialog title="添加单词" :visible.sync="dialogFormVisible" :before-close.stop="handleClose">
            <el-form :model="form">
                <el-form-item label="单词:" :label-width="formLabelWidth">
                    <el-input v-model="form.word" placeholder="请输入单词" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="音标:" :label-width="formLabelWidth">
                    <el-input v-model="form.yinbiao" placeholder="请输入单词" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="单词中文:" :label-width="formLabelWidth">
                    <el-input v-model="form.wordtranslate" placeholder="请输入单词" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="记忆提示:" :label-width="formLabelWidth">
                    <el-input v-model="form.tip" placeholder="请输入" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="单词句子:" :label-width="formLabelWidth">
                    <el-input v-model="form.sentence" placeholder="请输入单词" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="句子翻译:" :label-width="formLabelWidth">
                    <el-input v-model="form.sentanctranslate" placeholder="请输入单词" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="音频地址:" :label-width="formLabelWidth">
                    <el-input v-model="form.mediaadress" placeholder="请输入音频地址" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="其他:" :label-width="formLabelWidth">
                    <el-input v-model="form.other" placeholder="请输入单词" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="单词类型:" :label-width="formLabelWidth">
                    <!-- <el-input v-model="form.worker" autocomplete="off"></el-input> -->
                    <el-select v-model="form.type" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
   
                <!-- <el-form-item label="单词描述:" :label-width="formLabelWidth">
                    <el-input type="textarea" :rows="4" placeholder="可选" v-model="form.yongtu"
                        autocomplete="off"></el-input>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="addUpdataWord">添加单词</el-button></el-button></el-button></el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { get, post } from "@/axios/index.js"
import {addHandWrod} from "@/api/kyword.js"
    export default {
        name: "zdzydialogeditadd",
        props: ['dialogFormVisible','rowdata'],
        data() {
            return {
                visbledia: this.dialogFormVisible,
                formLabelWidth: '150px',
                initdata:{},
                form: {
                    word: '',
                    yinbiao:'',
                    wordtranslate:"",
                    tip:"",
                    sentence:"",
                    sentanctranslate:"",
                    mediaadress:"",
                    other:"",
                    type: '请选择类型',
                },
                options: [{
                    value: '3',
                    label: '3个字母单词'
                }, {
                    value: '4',
                    label: '4个字母单词'
                }, {
                    value: '5',
                    label: '5个字母单词'
                }, {
                    value: '6',
                    label: '6个字母单词'
                }, {
                    value: '7',
                    label: '7个字母单词'
                }, {
                    value: '8',
                    label: '8个字母单词'
                }, {
                    value: '9',
                    label: '9个字母单词'
                }, {
                    value: '10',
                    label: '10个字母单词'
                }, {
                    value: '11',
                    label: '11个字母单词'
                }, {
                    value: '12',
                    label: '12个字母单词'
                }, {
                    value: '13',
                    label: '13个字母单词'
                }, {
                    value: '14',
                    label: '14个字母单词'
                },
                ],


            }
        },
        created() {
            // this.visbledia=this.dialogFormVisible
            // //console.log(this.dialogFormVisible)
        },
        computed: {

        },

        watch: {
            rowdata:{
                handler(data){
                //console.log("编辑组件数据",data)
                this.fuzhi(data)
                }
            }
        },
        methods: {
            //赋值
            fuzhi(data){
                this.initdata=data
                this.form=data
                //console.log(this.form)
            //  for(let key in data){
            //     //console.log(key)
            //  }
            },
            show() {
                this.dialogFormVisible = true
            },
            //关闭
            handleClose() {
                this.$emit('onclose');
            },
            //确定
            addUpdataWord(data) {
                //发送请求，存到数据库
               this.HandAddwordList()
            },
          
            HandAddwordList(){
        
                if(this.form.word==""){
                    return this.$message({
                         message:"单词不能为空"
                    })
                }

                addHandWrod(this.form)
                    .then((res) => {
                         //看是否存在
                         if(res.data.status==1001){
                          return  this.$message({
                                message:res.data.msg,
                                type:'danger'
                            })
                         }
                         //添加成功
                        if(res.data.status==200){
                        this.$emit('onclose');
                        this.$emit('updateData');
                        this.$message({
                        message: res.data.msg,
                        type: 'success'
                    });
                }else{  //添加失败
                    this.$message({
                        message: res.data.msg,
                        type: 'primary'
                    });
                }
                    })
            },
    
         
        }
    }
</script>
<style scoped>
    .row-content {
        display: flex;
        flex-direction: column;


    }


    .classif-info {
        display: flex;
        text-align: left;
        font-size: 18px;
        font-weight: bold;
        font-weight: 400;
        color: #333333;
    }

    >>>.el-dialog__title {
        position: relative;
        top: 20px;
        left: 20px;
        font-size: 18px;
        font-weight: bold;
        color: #2A354E;
    }

    .testcone {
        font-weight: 400;
        color: #0067F5;
        border: 1px solid #0067F5;
        border-radius: 4px 4px 4px 4px;
    }

    .input-with-select {
        display: flex;
        flex: 1;
    }

    >>>.el-radio {
        text-align: left;
        padding: 10px 0;
    }


    >>>.el-input__suffix {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px !important;
        cursor: pointer;
    }

    /*  */
    >>>.el-dialog__header {
        margin: 0;
        padding: 0;
        height: 50px;
        text-align: left;
    }dialog



    >>>.el-form {
        /* height: 4rem; */
        position: relative;
        left: 20px;
        margin-right: 150px;
    }

    >>>.el-dialog__footer {
        /* padding: 0 0.2rem; */
        text-align: left;
        margin-left: 170px;
        position: relative;
        top:  -50px;
    }

    >>>.el-button--primary {
        background-color: #2CADD4;
    }

    >>>.el-input--suffix {
        display: flex;
        width: 100%;
    }

    >>>.el-select {
        display: flex;
        flex: 1;
    }
/* 在标签前面增加星号before，后面增加after */
/* 类名::before */
 >>>.el-form>div>label::before {
        content: ' *';
        color: red;
        font-size: 20px;
        position: relative;
        top: 5px !important;
    }

</style>


// WEBPACK FOOTER //
// src/components/word/zdzy-dialog-hand-add.vue